var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _g3, _path13, _path14, _path15, _g4, _path16, _path17, _path18, _g5, _path19, _path20, _path21, _g6, _path22, _path23, _path24, _g7, _path25, _path26, _path27, _g8, _path28, _path29, _path30, _g9, _path31, _path32, _path33, _g10, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _g11, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingletransitpolicyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 74,
    viewBox: "0 0 77 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1206 19.9688H17.687V33.2065H39.1206V19.9688Z",
    fill: "#E5E1E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7733 19.9688H2.78711V33.2065H17.7733V19.9688Z",
    fill: "#CCCACC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6706 11H17.7156V20.1438H31.6706V11Z",
    fill: "#E5E1E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7726 11H8.01514V20.1438H17.7726V11Z",
    fill: "#CCCACC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.421 21.9297H19.9082V23.7582H37.421V21.9297Z",
    fill: "#35384A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0297 23.4119L19.8977 23.4879L19.9082 21.9316L37.0297 21.9749V23.4119Z",
    fill: "#40455B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9082 23.7602L37.4214 21.9316H29.885L19.8977 23.0417L19.9082 23.7602Z",
    fill: "#7E86A5"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4636 23.8017H19.866V21.8887H37.4633V23.8017H37.4636ZM19.9505 23.7172H37.3788V21.9731H19.9505V23.7172Z",
    fill: "#35384A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.421 25.5898H19.9082V27.4187H37.421V25.5898Z",
    fill: "#35384A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0297 27.0705L19.8977 27.1465L19.9082 25.5898L37.0297 25.6334V27.0705Z",
    fill: "#40455B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9082 27.4187L37.4214 25.5898H29.885L19.8977 26.7002L19.9082 27.4187Z",
    fill: "#7E86A5"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4636 27.4602H19.866V25.5469H37.4633V27.4602H37.4636ZM19.9505 27.3758H37.3788V25.6313H19.9505V27.3758Z",
    fill: "#35384A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0607 12.8711H18.7722V14.7H31.0607V12.8711Z",
    fill: "#35384A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7861 14.352L18.7649 14.4284L18.7723 12.8711L30.7861 12.9147V14.352Z",
    fill: "#40455B"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7723 14.7L31.0609 12.8711H25.7727L18.7649 13.9815L18.7723 14.7Z",
    fill: "#7E86A5"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.103 14.7434H18.73V12.8301H31.103V14.7434ZM18.8145 14.659H31.0185V12.9145H18.8145V14.659Z",
    fill: "#35384A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.061 16.5293H18.7725V18.3582H31.061V16.5293Z",
    fill: "#35384A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7861 18.0099L18.7649 18.0863L18.7723 16.5293L30.7861 16.5729V18.0099Z",
    fill: "#40455B"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7723 18.3601L31.0609 16.5312H25.7727L18.7649 17.642L18.7723 18.3601Z",
    fill: "#7E86A5"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1032 18.3997H18.7302V16.4863H31.1032V18.3997ZM18.8147 18.3152H31.0188V16.5708H18.8147V18.3152Z",
    fill: "#35384A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.421 28.9824H19.9082V30.8113H37.421V28.9824Z",
    fill: "#35384A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0297 30.4643L19.8977 30.5407L19.9082 28.9844L37.0297 29.0276V30.4643Z",
    fill: "#40455B"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9082 30.8133L37.4214 28.9844H29.885L19.8977 30.0947L19.9082 30.8133Z",
    fill: "#7E86A5"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4636 30.8548H19.866V28.9414H37.4633V30.8548H37.4636ZM19.9505 30.7703H37.3788V29.0259H19.9505V30.7703Z",
    fill: "#35384A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2492 22.125H3.37256V23.9532H16.2492V22.125Z",
    fill: "#35384A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.961 23.6053L3.36523 23.6813L3.37267 22.125L15.961 22.1682V23.6053Z",
    fill: "#40455B"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37267 23.9532L16.2489 22.125H10.7079L3.36523 23.2354L3.37267 23.9532Z",
    fill: "#7E86A5"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2912 23.9947H3.33008V22.082H16.2912V23.9947ZM3.41491 23.9103H16.207V22.1665H3.41491V23.9103Z",
    fill: "#35384A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2496 25.5234H3.37305V27.3523H16.2496V25.5234Z",
    fill: "#35384A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.961 27.0014L3.36523 27.0784L3.37267 25.5215L15.961 25.5647V27.0014Z",
    fill: "#40455B"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37267 27.3504L16.2489 25.5215H10.7079L3.36523 26.6319L3.37267 27.3504Z",
    fill: "#7E86A5"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2914 27.3938H3.33032V25.4805H16.2914V27.3938ZM3.41515 27.3094H16.2073V25.5649H3.41515V27.3094Z",
    fill: "#35384A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1204 12.9805H8.94629V14.8094H17.1204V12.9805Z",
    fill: "#35384A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9374 14.4607L8.94141 14.5371L8.94614 12.9805L16.9374 13.0237V14.4607Z",
    fill: "#40455B"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94614 14.8094L17.1202 12.9805H13.6027L8.94141 14.0908L8.94614 14.8094Z",
    fill: "#7E86A5"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1626 14.8528H8.90405V12.9395H17.1626V14.8528ZM8.98854 14.7684H17.0782V13.0239H8.98854V14.7684Z",
    fill: "#35384A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1204 16.3789H8.94629V18.2078H17.1204V16.3789Z",
    fill: "#35384A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9376 17.8576L8.94165 17.9343L8.94638 16.377L16.9376 16.4205V17.8576Z",
    fill: "#40455B"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94638 18.2059L17.1205 16.377H13.6029L8.94165 17.4873L8.94638 18.2059Z",
    fill: "#7E86A5"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1626 18.2493H8.90405V16.3359H17.1626V18.2493ZM8.98854 18.1648H17.0782V16.4204H8.98854V18.1648Z",
    fill: "#35384A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2494 28.9199H3.3728V30.7485H16.2494V28.9199Z",
    fill: "#35384A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.961 30.4002L3.36523 30.4765L3.37267 28.9199L15.961 28.9632V30.4002Z",
    fill: "#40455B"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37267 30.7485L16.2489 28.9199H10.7079L3.36523 30.03L3.37267 30.7485Z",
    fill: "#7E86A5"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2914 30.79H3.33032V28.877H16.2914V30.79ZM3.41515 30.7055H16.2073V28.9614H3.41515V30.7055Z",
    fill: "#35384A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0172 26.2188H29.2461V32.4966H41.0172V26.2188Z",
    fill: "#46556B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0589 26.2188H41.0171V32.4966H47.0589V26.2188Z",
    fill: "#506A89"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.604 26.4297H29.3799V32.4984H29.604V26.4297Z",
    fill: "#3B495B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4097 26.4297H30.1863V32.4984H30.4097V26.4297Z",
    fill: "#3B495B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4837 26.4297H31.2603V32.4984H31.4837V26.4297Z",
    fill: "#3B495B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5579 26.4297H32.3345V32.4984H32.5579V26.4297Z",
    fill: "#3B495B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9006 26.4297H33.6772V32.4984H33.9006V26.4297Z",
    fill: "#3B495B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2432 26.4297H35.0198V32.4984H35.2432V26.4297Z",
    fill: "#3B495B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8544 26.4297H36.6306V32.4984H36.8544V26.4297Z",
    fill: "#3B495B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1975 26.4297H37.9734V32.4984H38.1975V26.4297Z",
    fill: "#3B495B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8081 26.4297H39.5847V32.4984H39.8081V26.4297Z",
    fill: "#3B495B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2254 26.4297H42.0017V32.4984H42.2254V26.4297Z",
    fill: "#577CA0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5682 26.4297H43.3445V32.4984H43.5682V26.4297Z",
    fill: "#577CA0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9107 26.4297H44.6873V32.4984H44.9107V26.4297Z",
    fill: "#577CA0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2533 26.4297H46.0303V32.4984H46.2533V26.4297Z",
    fill: "#577CA0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0649 26.0742H41.0061V26.4424H47.0649V26.0742Z",
    fill: "#3E4E5E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M41.006 26.0742H29.2349V26.4505H41.006V26.0742Z",
    fill: "#394656"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M41.006 32.3516H29.2349V32.7286H41.006V32.3516Z",
    fill: "#394656"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0567 32.3516H40.9976V32.7204H47.0567V32.3516Z",
    fill: "#3E4E5E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7123 26.0625H45.7861V32.4356H56.7123V26.0625Z",
    fill: "#0C83FD"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3205 26.0625H56.7119V32.4356H62.3205V26.0625Z",
    fill: "#59B8E7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1185 26.2754H45.9106V32.4364H46.1185V26.2754Z",
    fill: "#0F79D8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M46.866 26.2754H46.6584V32.4364H46.866V26.2754Z",
    fill: "#0F79D8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8629 26.2754H47.6558V32.4364H47.8629V26.2754Z",
    fill: "#0F79D8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8601 26.2754H48.6526V32.4364H48.8601V26.2754Z",
    fill: "#0F79D8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1066 26.2754H49.8994V32.4364H50.1066V26.2754Z",
    fill: "#0F79D8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M51.353 26.2754H51.1455V32.4364H51.353V26.2754Z",
    fill: "#0F79D8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8484 26.2754H52.6409V32.4364H52.8484V26.2754Z",
    fill: "#0F79D8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0948 26.2754H53.887V32.4364H54.0948V26.2754Z",
    fill: "#0F79D8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5905 26.2754H55.3833V32.4364H55.5905V26.2754Z",
    fill: "#0F79D8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M57.834 26.2754H57.6265V32.4364H57.834V26.2754Z",
    fill: "#48A6CC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0801 26.2754H58.8726V32.4364H59.0801V26.2754Z",
    fill: "#48A6CC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3267 26.2754H60.1191V32.4364H60.3267V26.2754Z",
    fill: "#48A6CC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5727 26.2754H61.3655V32.4364H61.5727V26.2754Z",
    fill: "#48A6CC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3259 25.9141H56.7021V26.2884H62.3259V25.9141Z",
    fill: "#2769A0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7019 25.9141H45.7754V26.2965H56.7019V25.9141Z",
    fill: "#205B95"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7019 32.2871H45.7754V32.6695H56.7019V32.2871Z",
    fill: "#205B95"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3185 32.2871H56.6943V32.6614H62.3185V32.2871Z",
    fill: "#2769A0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M71.107 26.0195H60.1812V32.393H71.107V26.0195Z",
    fill: "#E74600"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7163 26.0195H71.1074V32.393H76.7163V26.0195Z",
    fill: "#FF6B00"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7629 26.2324H60.5554V32.3937H60.7629V26.2324Z",
    fill: "#C43402"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5107 26.2324H61.3032V32.3937H61.5107V26.2324Z",
    fill: "#C43402"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5078 26.2324H62.3003V32.3937H62.5078V26.2324Z",
    fill: "#C43402"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5047 26.2324H63.2969V32.3937H63.5047V26.2324Z",
    fill: "#C43402"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7512 26.2324H64.5437V32.3937H64.7512V26.2324Z",
    fill: "#C43402"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9972 26.2324H65.79V32.3937H65.9972V26.2324Z",
    fill: "#C43402"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4928 26.2324H67.2856V32.3937H67.4928V26.2324Z",
    fill: "#C43402"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7393 26.2324H68.5317V32.3937H68.7393V26.2324Z",
    fill: "#C43402"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2351 26.2324H70.0276V32.3937H70.2351V26.2324Z",
    fill: "#C43402"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2296 26.2324H72.0217V32.3937H72.2296V26.2324Z",
    fill: "#EF6203"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4756 26.2324H73.2681V32.3937H73.4756V26.2324Z",
    fill: "#EF6203"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7221 26.2324H74.5149V32.3937H74.7221V26.2324Z",
    fill: "#EF6203"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9685 26.2324H75.761V32.3937H75.9685V26.2324Z",
    fill: "#EF6203"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7214 25.8711H71.0977V26.2457H76.7214V25.8711Z",
    fill: "#CD5A0D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0977 25.8711H60.1711V26.2535H71.0977V25.8711Z",
    fill: "#B7520D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0977 32.2441H60.1711V32.6269H71.0977V32.2441Z",
    fill: "#B7520D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7131 32.2441H71.0894V32.6188H76.7131V32.2441Z",
    fill: "#CD5A0D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M73.745 29.5527H72.925V32.718H73.745V29.5527Z",
    fill: "#2F302B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7311 29.8457H73.262V32.3222H73.7311V29.8457Z",
    fill: "#41423C"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M60.816 33.9492H13.7661V56.6794H60.816V33.9492Z",
    fill: "#383A3A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1171 33.9492L58.5942 56.6794L62.9236 56.7122C62.9236 56.7122 65.5209 47.6656 70.2261 43.0937C70.2261 43.0937 75.4541 38.3907 76.6303 34.3414C76.6303 34.3414 71.4022 33.9492 59.1171 33.9492Z",
    fill: "#585A5B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5947 34.1516L17.2635 56.4963L12.949 56.4598C12.949 56.4598 10.6805 47.3788 6.15042 42.7093C6.15042 42.7093 1.10286 37.8904 0.079834 33.8685C0.079834 33.8685 5.31834 33.6827 17.5947 34.1516Z",
    fill: "#383A3A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7 56.6794L12.9385 56.7227L11.958 53.2395L58.7 53.1523V56.6794Z",
    fill: "#FFA700"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9234 56.7122L58.7002 56.6794V53.1523L64.0996 53.2827L62.9234 56.7122Z",
    fill: "#FFB43B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M11.958 53.2395L12.4156 54.8938L58.6811 54.6762L58.7 53.1523L11.958 53.2395Z",
    fill: "#DD8903"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6812 54.6762L63.5824 54.7417L64.0995 53.2827L58.7001 53.1523L58.6812 54.6762Z",
    fill: "#E89C2E"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1171 33.0352H0V34.6897H59.1171V33.0352Z",
    fill: "#E89C2E"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9346 33.0352H59.0679V34.6897H76.9346V33.0352Z",
    fill: "#EFA645"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0519 33.0352H0V33.8185H59.0519V33.0352Z",
    fill: "#CE8938"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9241 33.0352H59.0679V33.803H76.9241V33.0352Z",
    fill: "#E59C45"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68627 37.3194C7.68627 37.8643 7.24454 38.3065 6.69873 38.3065C6.15392 38.3065 5.71118 37.8643 5.71118 37.3194C5.71118 36.7742 6.15358 36.332 6.69873 36.332C7.24454 36.3324 7.68627 36.7742 7.68627 37.3194Z",
    fill: "#11496E"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69852 38.4764C6.06077 38.4764 5.54199 37.9578 5.54199 37.3204C5.54199 36.6826 6.06077 36.1641 6.69852 36.1641C7.33626 36.1641 7.85505 36.6826 7.85505 37.3204C7.85538 37.9578 7.3366 38.4764 6.69852 38.4764ZM6.69852 36.5022C6.24733 36.5022 5.87996 36.8694 5.87996 37.3207C5.87996 37.7717 6.24699 38.1389 6.69852 38.1389C7.15004 38.1389 7.51708 37.7717 7.51708 37.3207C7.51742 36.8691 7.15004 36.5022 6.69852 36.5022Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0009 37.3194C11.0009 37.8643 10.5585 38.3065 10.0133 38.3065C9.46717 38.3065 9.02612 37.8643 9.02612 37.3194C9.02612 36.7742 9.46717 36.332 10.0133 36.332C10.5581 36.3324 11.0009 36.7742 11.0009 37.3194Z",
    fill: "#11496E"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0134 38.4764C9.37596 38.4764 8.85718 37.9578 8.85718 37.3204C8.85718 36.6826 9.37596 36.1641 10.0134 36.1641C10.6511 36.1641 11.1699 36.6826 11.1699 37.3204C11.1699 37.9578 10.6511 38.4764 10.0134 38.4764ZM10.0134 36.5022C9.56218 36.5022 9.19515 36.8694 9.19515 37.3207C9.19515 37.7717 9.56218 38.1389 10.0134 38.1389C10.4646 38.1389 10.8319 37.7717 10.8319 37.3207C10.8319 36.8691 10.4646 36.5022 10.0134 36.5022Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3155 37.3194C14.3155 37.8643 13.8727 38.3065 13.3279 38.3065C12.7821 38.3065 12.3394 37.8643 12.3394 37.3194C12.3394 36.7742 12.7818 36.332 13.3279 36.332C13.8727 36.3324 14.3155 36.7742 14.3155 37.3194Z",
    fill: "#11496E"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3277 38.4764C12.6893 38.4764 12.1702 37.9578 12.1702 37.3204C12.1702 36.6826 12.6893 36.1641 13.3277 36.1641C13.9655 36.1641 14.4842 36.6826 14.4842 37.3204C14.4846 37.9578 13.9655 38.4764 13.3277 38.4764ZM13.3277 36.5022C12.8758 36.5022 12.5081 36.8694 12.5081 37.3207C12.5081 37.7717 12.8758 38.1389 13.3277 38.1389C13.7792 38.1389 14.1463 37.7717 14.1463 37.3207C14.1466 36.8691 13.7792 36.5022 13.3277 36.5022Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6301 37.3194C17.6301 37.8643 17.1873 38.3065 16.6418 38.3065C16.097 38.3065 15.6543 37.8643 15.6543 37.3194C15.6543 36.7742 16.097 36.332 16.6418 36.332C17.1873 36.3324 17.6301 36.7742 17.6301 37.3194Z",
    fill: "#11496E"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6414 38.4764C16.0036 38.4764 15.4849 37.9578 15.4849 37.3204C15.4849 36.6826 16.0036 36.1641 16.6414 36.1641C17.2795 36.1641 17.7986 36.6826 17.7986 37.3204C17.7989 37.9578 17.2798 38.4764 16.6414 38.4764ZM16.6414 36.5022C16.1902 36.5022 15.8228 36.8694 15.8228 37.3207C15.8228 37.7717 16.1899 38.1389 16.6414 38.1389C17.0933 38.1389 17.4606 37.7717 17.4606 37.3207C17.461 36.8691 17.0933 36.5022 16.6414 36.5022Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M20.943 37.3194C20.943 37.8643 20.5006 38.3065 19.9558 38.3065C19.4107 38.3065 18.9683 37.8643 18.9683 37.3194C18.9683 36.7742 19.411 36.332 19.9558 36.332C20.5006 36.3324 20.943 36.7742 20.943 37.3194Z",
    fill: "#11496E"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9558 38.4764C19.3181 38.4764 18.7993 37.9578 18.7993 37.3204C18.7993 36.6826 19.3181 36.1641 19.9558 36.1641C20.5933 36.1641 21.112 36.6826 21.112 37.3204C21.112 37.9578 20.5933 38.4764 19.9558 38.4764ZM19.9558 36.5022C19.5043 36.5022 19.1373 36.8694 19.1373 37.3207C19.1373 37.7717 19.5047 38.1389 19.9558 38.1389C20.407 38.1389 20.7741 37.7717 20.7741 37.3207C20.7741 36.8691 20.407 36.5022 19.9558 36.5022Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 37.3194C24.2578 37.8643 23.8151 38.3065 23.2703 38.3065C22.7238 38.3065 22.2817 37.8643 22.2817 37.3194C22.2817 36.7742 22.7241 36.332 23.2703 36.332C23.8154 36.3324 24.2578 36.7742 24.2578 37.3194Z",
    fill: "#11496E"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2703 38.4764C22.6319 38.4764 22.1128 37.9578 22.1128 37.3204C22.1128 36.6826 22.6322 36.1641 23.2703 36.1641C23.9081 36.1641 24.4269 36.6826 24.4269 37.3204C24.4269 37.9578 23.9081 38.4764 23.2703 38.4764ZM23.2703 36.5022C22.8185 36.5022 22.4508 36.8694 22.4508 37.3207C22.4508 37.7717 22.8185 38.1389 23.2703 38.1389C23.7219 38.1389 24.0889 37.7717 24.0889 37.3207C24.0889 36.8691 23.7219 36.5022 23.2703 36.5022Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5731 37.3194C27.5731 37.8643 27.13 38.3065 26.5842 38.3065C26.0394 38.3065 25.5967 37.8643 25.5967 37.3194C25.5967 36.7742 26.0394 36.332 26.5842 36.332C27.13 36.3324 27.5731 36.7742 27.5731 37.3194Z",
    fill: "#11496E"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5838 38.4764C25.946 38.4764 25.4272 37.9578 25.4272 37.3204C25.4272 36.6826 25.946 36.1641 26.5838 36.1641C27.2222 36.1641 27.7417 36.6826 27.7417 37.3204C27.742 37.9578 27.2222 38.4764 26.5838 38.4764ZM26.5838 36.5022C26.1326 36.5022 25.7652 36.8694 25.7652 37.3207C25.7652 37.7717 26.1322 38.1389 26.5838 38.1389C27.036 38.1389 27.4037 37.7717 27.4037 37.3207C27.404 36.8691 27.036 36.5022 26.5838 36.5022Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8857 37.3194C30.8857 37.8643 30.444 38.3065 29.8982 38.3065C29.3524 38.3065 28.9106 37.8643 28.9106 37.3194C28.9106 36.7742 29.3527 36.332 29.8982 36.332C30.444 36.3324 30.8857 36.7742 30.8857 37.3194Z",
    fill: "#11496E"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8982 38.4764C29.2605 38.4764 28.7417 37.9578 28.7417 37.3204C28.7417 36.6826 29.2605 36.1641 29.8982 36.1641C30.536 36.1641 31.0548 36.6826 31.0548 37.3204C31.0548 37.9578 30.536 38.4764 29.8982 38.4764ZM29.8982 36.5022C29.4467 36.5022 29.0797 36.8694 29.0797 37.3207C29.0797 37.7717 29.447 38.1389 29.8982 38.1389C30.3494 38.1389 30.7168 37.7717 30.7168 37.3207C30.7168 36.8691 30.3494 36.5022 29.8982 36.5022Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68627 37.3194C7.68627 37.8643 7.24454 38.3065 6.69873 38.3065C6.15392 38.3065 5.71118 37.8643 5.71118 37.3194C5.71118 36.7742 6.15358 36.332 6.69873 36.332C7.24454 36.3324 7.68627 36.7742 7.68627 37.3194Z",
    fill: "#11496E"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69852 38.4764C6.06077 38.4764 5.54199 37.9578 5.54199 37.3204C5.54199 36.6826 6.06077 36.1641 6.69852 36.1641C7.33626 36.1641 7.85505 36.6826 7.85505 37.3204C7.85538 37.9578 7.3366 38.4764 6.69852 38.4764ZM6.69852 36.5022C6.24733 36.5022 5.87996 36.8694 5.87996 37.3207C5.87996 37.7717 6.24699 38.1389 6.69852 38.1389C7.15004 38.1389 7.51708 37.7717 7.51708 37.3207C7.51742 36.8691 7.15004 36.5022 6.69852 36.5022Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0009 37.3194C11.0009 37.8643 10.5585 38.3065 10.0133 38.3065C9.46717 38.3065 9.02612 37.8643 9.02612 37.3194C9.02612 36.7742 9.46717 36.332 10.0133 36.332C10.5581 36.3324 11.0009 36.7742 11.0009 37.3194Z",
    fill: "#11496E"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0134 38.4764C9.37596 38.4764 8.85718 37.9578 8.85718 37.3204C8.85718 36.6826 9.37596 36.1641 10.0134 36.1641C10.6511 36.1641 11.1699 36.6826 11.1699 37.3204C11.1699 37.9578 10.6511 38.4764 10.0134 38.4764ZM10.0134 36.5022C9.56218 36.5022 9.19515 36.8694 9.19515 37.3207C9.19515 37.7717 9.56218 38.1389 10.0134 38.1389C10.4646 38.1389 10.8319 37.7717 10.8319 37.3207C10.8319 36.8691 10.4646 36.5022 10.0134 36.5022Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3155 37.3194C14.3155 37.8643 13.8727 38.3065 13.3279 38.3065C12.7821 38.3065 12.3394 37.8643 12.3394 37.3194C12.3394 36.7742 12.7818 36.332 13.3279 36.332C13.8727 36.3324 14.3155 36.7742 14.3155 37.3194Z",
    fill: "#11496E"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3277 38.4764C12.6893 38.4764 12.1702 37.9578 12.1702 37.3204C12.1702 36.6826 12.6893 36.1641 13.3277 36.1641C13.9655 36.1641 14.4842 36.6826 14.4842 37.3204C14.4846 37.9578 13.9655 38.4764 13.3277 38.4764ZM13.3277 36.5022C12.8758 36.5022 12.5081 36.8694 12.5081 37.3207C12.5081 37.7717 12.8758 38.1389 13.3277 38.1389C13.7792 38.1389 14.1463 37.7717 14.1463 37.3207C14.1466 36.8691 13.7792 36.5022 13.3277 36.5022Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6301 37.3194C17.6301 37.8643 17.1873 38.3065 16.6418 38.3065C16.097 38.3065 15.6543 37.8643 15.6543 37.3194C15.6543 36.7742 16.097 36.332 16.6418 36.332C17.1873 36.3324 17.6301 36.7742 17.6301 37.3194Z",
    fill: "#11496E"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6414 38.4764C16.0036 38.4764 15.4849 37.9578 15.4849 37.3204C15.4849 36.6826 16.0036 36.1641 16.6414 36.1641C17.2795 36.1641 17.7986 36.6826 17.7986 37.3204C17.7989 37.9578 17.2798 38.4764 16.6414 38.4764ZM16.6414 36.5022C16.1902 36.5022 15.8228 36.8694 15.8228 37.3207C15.8228 37.7717 16.1899 38.1389 16.6414 38.1389C17.0933 38.1389 17.4606 37.7717 17.4606 37.3207C17.461 36.8691 17.0933 36.5022 16.6414 36.5022Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M20.943 37.3194C20.943 37.8643 20.5006 38.3065 19.9558 38.3065C19.4107 38.3065 18.9683 37.8643 18.9683 37.3194C18.9683 36.7742 19.411 36.332 19.9558 36.332C20.5006 36.3324 20.943 36.7742 20.943 37.3194Z",
    fill: "#11496E"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9558 38.4764C19.3181 38.4764 18.7993 37.9578 18.7993 37.3204C18.7993 36.6826 19.3181 36.1641 19.9558 36.1641C20.5933 36.1641 21.112 36.6826 21.112 37.3204C21.112 37.9578 20.5933 38.4764 19.9558 38.4764ZM19.9558 36.5022C19.5043 36.5022 19.1373 36.8694 19.1373 37.3207C19.1373 37.7717 19.5047 38.1389 19.9558 38.1389C20.407 38.1389 20.7741 37.7717 20.7741 37.3207C20.7741 36.8691 20.407 36.5022 19.9558 36.5022Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 37.3194C24.2578 37.8643 23.8151 38.3065 23.2703 38.3065C22.7238 38.3065 22.2817 37.8643 22.2817 37.3194C22.2817 36.7742 22.7241 36.332 23.2703 36.332C23.8154 36.3324 24.2578 36.7742 24.2578 37.3194Z",
    fill: "#11496E"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2703 38.4764C22.6319 38.4764 22.1128 37.9578 22.1128 37.3204C22.1128 36.6826 22.6322 36.1641 23.2703 36.1641C23.9081 36.1641 24.4269 36.6826 24.4269 37.3204C24.4269 37.9578 23.9081 38.4764 23.2703 38.4764ZM23.2703 36.5022C22.8185 36.5022 22.4508 36.8694 22.4508 37.3207C22.4508 37.7717 22.8185 38.1389 23.2703 38.1389C23.7219 38.1389 24.0889 37.7717 24.0889 37.3207C24.0889 36.8691 23.7219 36.5022 23.2703 36.5022Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5731 37.3194C27.5731 37.8643 27.13 38.3065 26.5842 38.3065C26.0394 38.3065 25.5967 37.8643 25.5967 37.3194C25.5967 36.7742 26.0394 36.332 26.5842 36.332C27.13 36.3324 27.5731 36.7742 27.5731 37.3194Z",
    fill: "#11496E"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5838 38.4764C25.946 38.4764 25.4272 37.9578 25.4272 37.3204C25.4272 36.6826 25.946 36.1641 26.5838 36.1641C27.2222 36.1641 27.7417 36.6826 27.7417 37.3204C27.742 37.9578 27.2222 38.4764 26.5838 38.4764ZM26.5838 36.5022C26.1326 36.5022 25.7652 36.8694 25.7652 37.3207C25.7652 37.7717 26.1322 38.1389 26.5838 38.1389C27.036 38.1389 27.4037 37.7717 27.4037 37.3207C27.404 36.8691 27.036 36.5022 26.5838 36.5022Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8857 37.3194C30.8857 37.8643 30.444 38.3065 29.8982 38.3065C29.3524 38.3065 28.9106 37.8643 28.9106 37.3194C28.9106 36.7742 29.3527 36.332 29.8982 36.332C30.444 36.3324 30.8857 36.7742 30.8857 37.3194Z",
    fill: "#11496E"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8982 38.4764C29.2605 38.4764 28.7417 37.9578 28.7417 37.3204C28.7417 36.6826 29.2605 36.1641 29.8982 36.1641C30.536 36.1641 31.0548 36.6826 31.0548 37.3204C31.0548 37.9578 30.536 38.4764 29.8982 38.4764ZM29.8982 36.5022C29.4467 36.5022 29.0797 36.8694 29.0797 37.3207C29.0797 37.7717 29.447 38.1389 29.8982 38.1389C30.3494 38.1389 30.7168 37.7717 30.7168 37.3207C30.7168 36.8691 30.3494 36.5022 29.8982 36.5022Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4548 37.3194C34.4548 37.8643 34.0124 38.3065 33.4672 38.3065C32.9211 38.3065 32.479 37.8643 32.479 37.3194C32.479 36.7742 32.9214 36.332 33.4672 36.332C34.0127 36.3324 34.4548 36.7742 34.4548 37.3194Z",
    fill: "#11496E"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4678 38.4764C32.8297 38.4764 32.3105 37.9578 32.3105 37.3204C32.3105 36.6826 32.8297 36.1641 33.4678 36.1641C34.1055 36.1641 34.6243 36.6826 34.6243 37.3204C34.6239 37.9578 34.1052 38.4764 33.4678 38.4764ZM33.4678 36.5022C33.0159 36.5022 32.6485 36.8694 32.6485 37.3207C32.6485 37.7717 33.0159 38.1389 33.4678 38.1389C33.9193 38.1389 34.2863 37.7717 34.2863 37.3207C34.286 36.8691 33.9189 36.5022 33.4678 36.5022Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7692 37.3194C37.7692 37.8643 37.3268 38.3065 36.7817 38.3065C36.2362 38.3065 35.7935 37.8643 35.7935 37.3194C35.7935 36.7742 36.2362 36.332 36.7817 36.332C37.3268 36.3324 37.7692 36.7742 37.7692 37.3194Z",
    fill: "#11496E"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7817 38.4764C36.1436 38.4764 35.6245 37.9578 35.6245 37.3204C35.6245 36.6826 36.1436 36.1641 36.7817 36.1641C37.4195 36.1641 37.9382 36.6826 37.9382 37.3204C37.9382 37.9578 37.4195 38.4764 36.7817 38.4764ZM36.7817 36.5022C36.3302 36.5022 35.9625 36.8694 35.9625 37.3207C35.9625 37.7717 36.3299 38.1389 36.7817 38.1389C37.2329 38.1389 37.6003 37.7717 37.6003 37.3207C37.6003 36.8691 37.2329 36.5022 36.7817 36.5022Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0843 37.3194C41.0843 37.8643 40.6413 38.3065 40.0955 38.3065C39.5506 38.3065 39.1079 37.8643 39.1079 37.3194C39.1079 36.7742 39.5503 36.332 40.0955 36.332C40.6416 36.3324 41.0843 36.7742 41.0843 37.3194Z",
    fill: "#11496E"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0955 38.4764C39.4577 38.4764 38.939 37.9578 38.939 37.3204C38.939 36.6826 39.4577 36.1641 40.0955 36.1641C40.7339 36.1641 41.2534 36.6826 41.2534 37.3204C41.2534 37.9578 40.7339 38.4764 40.0955 38.4764ZM40.0955 36.5022C39.6443 36.5022 39.2769 36.8694 39.2769 37.3207C39.2769 37.7717 39.644 38.1389 40.0955 38.1389C40.5477 38.1389 40.9154 37.7717 40.9154 37.3207C40.9154 36.8691 40.5477 36.5022 40.0955 36.5022Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3974 37.3194C44.3974 37.8643 43.9554 38.3065 43.4099 38.3065C42.8641 38.3065 42.4224 37.8643 42.4224 37.3194C42.4224 36.7742 42.8644 36.332 43.4099 36.332C43.9557 36.3324 44.3974 36.7742 44.3974 37.3194Z",
    fill: "#11496E"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4099 38.4764C42.7722 38.4764 42.2534 37.9578 42.2534 37.3204C42.2534 36.6826 42.7722 36.1641 43.4099 36.1641C44.0477 36.1641 44.5665 36.6826 44.5665 37.3204C44.5665 37.9578 44.0477 38.4764 43.4099 38.4764ZM43.4099 36.5022C42.9588 36.5022 42.5914 36.8694 42.5914 37.3207C42.5914 37.7717 42.9588 38.1389 43.4099 38.1389C43.8611 38.1389 44.2285 37.7717 44.2285 37.3207C44.2285 36.8691 43.8615 36.5022 43.4099 36.5022Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7121 37.3194C47.7121 37.8643 47.2697 38.3065 46.7249 38.3065C46.1794 38.3065 45.7363 37.8643 45.7363 37.3194C45.7363 36.7742 46.1794 36.332 46.7249 36.332C47.2697 36.3324 47.7121 36.7742 47.7121 37.3194Z",
    fill: "#11496E"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7249 38.4764C46.0865 38.4764 45.5674 37.9578 45.5674 37.3204C45.5674 36.6826 46.0865 36.1641 46.7249 36.1641C47.3627 36.1641 47.8811 36.6826 47.8811 37.3204C47.8811 37.9578 47.3623 38.4764 46.7249 38.4764ZM46.7249 36.5022C46.2731 36.5022 45.9054 36.8694 45.9054 37.3207C45.9054 37.7717 46.2731 38.1389 46.7249 38.1389C47.1761 38.1389 47.5431 37.7717 47.5431 37.3207C47.5431 36.8691 47.1758 36.5022 46.7249 36.5022Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0267 37.3194C51.0267 37.8643 50.584 38.3065 50.0382 38.3065C49.4934 38.3065 49.0503 37.8643 49.0503 37.3194C49.0503 36.7742 49.4934 36.332 50.0382 36.332C50.584 36.3324 51.0267 36.7742 51.0267 37.3194Z",
    fill: "#11496E"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0382 38.4764C49.4005 38.4764 48.8813 37.9578 48.8813 37.3204C48.8813 36.6826 49.4005 36.1641 50.0382 36.1641C50.6766 36.1641 51.1958 36.6826 51.1958 37.3204C51.1958 37.9578 50.6763 38.4764 50.0382 38.4764ZM50.0382 36.5022C49.5867 36.5022 49.2193 36.8694 49.2193 37.3207C49.2193 37.7717 49.5867 38.1389 50.0382 38.1389C50.4901 38.1389 50.8578 37.7717 50.8578 37.3207C50.8578 36.8691 50.4901 36.5022 50.0382 36.5022Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3398 37.3194C54.3398 37.8643 53.8984 38.3065 53.3523 38.3065C52.8071 38.3065 52.3647 37.8643 52.3647 37.3194C52.3647 36.7742 52.8075 36.332 53.3523 36.332C53.8988 36.3324 54.3398 36.7742 54.3398 37.3194Z",
    fill: "#11496E"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3523 38.4764C52.7146 38.4764 52.1958 37.9578 52.1958 37.3204C52.1958 36.6826 52.7146 36.1641 53.3523 36.1641C53.9901 36.1641 54.5089 36.6826 54.5089 37.3204C54.5089 37.9578 53.9901 38.4764 53.3523 38.4764ZM53.3523 36.5022C52.9011 36.5022 52.5338 36.8694 52.5338 37.3207C52.5338 37.7717 52.9011 38.1389 53.3523 38.1389C53.8039 38.1389 54.1709 37.7717 54.1709 37.3207C54.1709 36.8691 53.8039 36.5022 53.3523 36.5022Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6542 37.3194C57.6542 37.8643 57.2118 38.3065 56.6667 38.3065C56.1209 38.3065 55.6785 37.8643 55.6785 37.3194C55.6785 36.7742 56.1212 36.332 56.6667 36.332C57.2118 36.3324 57.6542 36.7742 57.6542 37.3194Z",
    fill: "#11496E"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M56.667 38.4764C56.0289 38.4764 55.5098 37.9578 55.5098 37.3204C55.5098 36.6826 56.0289 36.1641 56.667 36.1641C57.3047 36.1641 57.8235 36.6826 57.8235 37.3204C57.8232 37.9578 57.3044 38.4764 56.667 38.4764ZM56.667 36.5022C56.2151 36.5022 55.8477 36.8694 55.8477 37.3207C55.8477 37.7717 56.2151 38.1389 56.667 38.1389C57.1182 38.1389 57.4855 37.7717 57.4855 37.3207C57.4852 36.8691 57.1182 36.5022 56.667 36.5022Z",
    fill: "white"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7246 50.5083L50.6218 56.7233L37.5522 56.6351L46.7879 33.7891L59.117 33.8323L58.7246 50.5083Z",
    fill: "black"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9314 32.3086H0.14624V33.0342H58.9314V32.3086Z",
    fill: "#2F302B"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9314 29.1426H0.14624V29.8682H58.9314V29.1426Z",
    fill: "#2F302B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0.966152 29.582H0.14624V32.7473H0.966152V29.582Z",
    fill: "#2F302B"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51718 29.582H2.69727V32.7473H3.51718V29.582Z",
    fill: "#2F302B"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0683 29.582H5.24805V32.7473H6.0683V29.582Z",
    fill: "#2F302B"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98348 29.582H8.16357V32.7473H8.98348V29.582Z",
    fill: "#2F302B"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2633 29.582H11.4434V32.7473H12.2633V29.582Z",
    fill: "#2F302B"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5429 29.582H14.7227V32.7473H15.5429V29.582Z",
    fill: "#2F302B"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8229 29.582H18.0027V32.7473H18.8229V29.582Z",
    fill: "#2F302B"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4664 29.582H21.6465V32.7473H22.4664V29.582Z",
    fill: "#2F302B"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1112 29.582H25.2913V32.7473H26.1112V29.582Z",
    fill: "#2F302B"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7551 29.582H28.9348V32.7473H29.7551V29.582Z",
    fill: "#2F302B"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M34.128 29.582H33.3081V32.7473H34.128V29.582Z",
    fill: "#2F302B"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1363 29.582H37.3164V32.7473H38.1363V29.582Z",
    fill: "#2F302B"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1449 29.582H41.325V32.7473H42.1449V29.582Z",
    fill: "#2F302B"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1537 29.582H45.3337V32.7473H46.1537V29.582Z",
    fill: "#2F302B"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7977 29.582H48.9778V32.7473H49.7977V29.582Z",
    fill: "#2F302B"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1708 29.582H53.3506V32.7473H54.1708V29.582Z",
    fill: "#2F302B"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9083 29.582H58.0884V32.7473H58.9083V29.582Z",
    fill: "#2F302B"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0.967485 29.8594H0.498047V32.3355H0.967485V29.8594Z",
    fill: "#41423C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51851 29.8457H3.04907V32.3222H3.51851V29.8457Z",
    fill: "#41423C"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05455 29.8594H5.58545V32.3355H6.05455V29.8594Z",
    fill: "#41423C"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97237 29.8594H8.50293V32.3355H8.97237V29.8594Z",
    fill: "#41423C"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2568 29.8594H11.7874V32.3355H12.2568V29.8594Z",
    fill: "#41423C"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5258 29.875H15.0564V32.3518H15.5258V29.875Z",
    fill: "#41423C"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8103 29.875H18.3408V32.3518H18.8103V29.875Z",
    fill: "#41423C"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4611 29.875H21.9917V32.3518H22.4611V29.875Z",
    fill: "#41423C"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0968 29.875H25.6277V32.3518H26.0968V29.875Z",
    fill: "#41423C"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7622 29.8594H29.2927V32.3355H29.7622V29.8594Z",
    fill: "#41423C"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1311 29.875H33.6616V32.3518H34.1311V29.875Z",
    fill: "#41423C"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1191 29.875H37.6497V32.3518H38.1191V29.875Z",
    fill: "#41423C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1359 29.875H41.6665V32.3518H42.1359V29.875Z",
    fill: "#41423C"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1529 29.8594H45.6838V32.3355H46.1529V29.8594Z",
    fill: "#41423C"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7893 29.8594H49.3198V32.3355H49.7893V29.8594Z",
    fill: "#41423C"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1578 29.875H53.6887V32.3518H54.1578V29.875Z",
    fill: "#41423C"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8938 29.875H58.4243V32.3518H58.8938V29.875Z",
    fill: "#41423C"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3131 29.6113H60.4932V32.7766H61.3131V29.6113Z",
    fill: "#2F302B"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2983 29.9023H60.8289V32.3788H61.2983V29.9023Z",
    fill: "#41423C"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M64.714 29.5527H63.894V32.718H64.714V29.5527Z",
    fill: "#2F302B"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6994 29.8457H64.23V32.3222H64.6994V29.8457Z",
    fill: "#41423C"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8512 29.4941H67.0312V32.6594H67.8512V29.4941Z",
    fill: "#2F302B"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8365 29.7871H67.3674V32.2632H67.8365V29.7871Z",
    fill: "#41423C"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6368 29.5234H69.8169V32.6887H70.6368V29.5234Z",
    fill: "#2F302B"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6224 29.8164H70.1533V32.2936H70.6224V29.8164Z",
    fill: "#41423C"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0001 29.1426H58.9316V29.875H77.0001V29.1426Z",
    fill: "#393A35"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0001 32.3086H58.9316V33.041H77.0001V32.3086Z",
    fill: "#393A35"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1194 53.6577C61.727 52.0136 58.257 50.5333 55.2664 53.1641C52.2753 55.7947 49.7636 54.4802 47.0122 53.1641C44.2601 51.848 42.2262 51.5197 38.758 53.4932C35.2877 55.4656 33.3738 55.3011 30.2635 53.6577C27.1531 52.0136 25.2392 52.0136 22.8464 53.1641C20.4533 54.315 18.0608 53.6577 15.0708 52.8341C12.0794 52.0132 11.123 50.5329 7.77268 52.8341C6.70571 53.5685 5.82159 53.8502 5.11084 53.8948V57.5803C5.82193 57.5357 6.70571 57.2543 7.77268 56.5203C11.123 54.2194 12.0794 55.6974 15.0708 56.5203C18.0611 57.3425 20.4533 58.0005 22.8464 56.8493C25.2389 55.6977 27.1531 55.6977 30.2635 57.3425C33.3738 58.9876 35.2877 59.1511 38.758 57.1787C42.2262 55.2059 44.2604 55.5349 47.0122 56.8493C49.7636 58.1654 52.2753 59.4802 55.2664 56.8493C58.2574 54.2198 61.727 55.6977 64.1194 57.3425C66.0824 58.6924 69.2535 58.3799 71.5186 57.407V53.7222C69.2535 54.6947 66.0824 55.0069 64.1194 53.6577Z",
    fill: "#9CDCFE"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1194 57.3423C61.727 55.6975 58.257 54.2196 55.2664 56.8491C52.2753 59.48 49.7636 58.1652 47.0122 56.8491C44.2601 55.5343 42.2262 55.2057 38.758 57.1785C35.2877 59.1513 33.3738 58.9878 30.2635 57.3423C27.1531 55.6975 25.2392 55.6975 22.8464 56.8491C20.4533 58.0004 18.0608 57.3423 15.0708 56.5201C12.0794 55.6972 11.123 54.2193 7.77268 56.5201C6.70571 57.2541 5.82159 57.5355 5.11084 57.5801V61.8521C5.82193 61.8078 6.70571 61.5257 7.77268 60.793C11.123 58.4905 12.0794 59.9705 15.0708 60.793C18.0611 61.6149 20.4533 62.2723 22.8464 61.1221C25.2389 59.9708 27.1531 59.9708 30.2635 61.6149C33.3738 63.2594 35.2877 63.4239 38.758 61.4504C42.2262 59.4783 44.2604 59.8066 47.0122 61.1221C49.7636 62.4371 52.2753 63.7519 55.2664 61.1221C58.2574 58.4905 61.727 59.9708 64.1194 61.6149C66.0824 62.9641 69.2535 62.6523 71.5186 61.6791V57.4068C69.2535 58.3797 66.0824 58.6922 64.1194 57.3423Z",
    fill: "#86D5FE"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1487 19.4902H39.2229V26.0218H50.1487V19.4902Z",
    fill: "#E74600"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7575 19.4902H50.1489V26.0218H55.7575V19.4902Z",
    fill: "#FF6B00"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8044 19.707H39.5969V26.021H39.8044V19.707Z",
    fill: "#C43402"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M40.552 19.707H40.3445V26.021H40.552V19.707Z",
    fill: "#C43402"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5487 19.707H41.3416V26.021H41.5487V19.707Z",
    fill: "#C43402"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5465 19.707H42.3386V26.021H42.5465V19.707Z",
    fill: "#C43402"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7927 19.707H43.5852V26.021H43.7927V19.707Z",
    fill: "#C43402"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0384 19.707H44.8315V26.021H45.0384V19.707Z",
    fill: "#C43402"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5343 19.707H46.3271V26.021H46.5343V19.707Z",
    fill: "#C43402"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M47.781 19.707H47.5735V26.021H47.781V19.707Z",
    fill: "#C43402"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2763 19.707H49.0691V26.021H49.2763V19.707Z",
    fill: "#C43402"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2708 19.707H51.063V26.021H51.2708V19.707Z",
    fill: "#EF6203"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5171 19.707H52.3096V26.021H52.5171V19.707Z",
    fill: "#EF6203"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7631 19.707H53.5559V26.021H53.7631V19.707Z",
    fill: "#EF6203"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0098 19.707H54.8022V26.021H55.0098V19.707Z",
    fill: "#EF6203"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7628 19.3379H50.1387V19.722H55.7628V19.3379Z",
    fill: "#CD5A0D"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1387 19.3379H39.2122V19.7297H50.1387V19.3379Z",
    fill: "#B7520D"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1387 25.8711H39.2122V26.263H50.1387V25.8711Z",
    fill: "#B7520D"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7549 25.8711H50.1311V26.2552H55.7549V25.8711Z",
    fill: "#CD5A0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingletransitpolicyicon);
export default __webpack_public_path__ + "static/media/single transit policy icon.24633f351b7069f406fa8bd2b67ffb45.svg";
export { ForwardRef as ReactComponent };